(function () {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const openButton = event.target.closest('[data-tbh-size-open]');
    if (openButton instanceof HTMLElement) {
      event.preventDefault();

      const modalId = openButton.getAttribute('aria-controls');
      const modal = modalId ? document.getElementById(modalId) : null;

      if (modal instanceof HTMLDialogElement && !modal.open) {
        modal.showModal();
      }

      return;
    }

    const closeButton = event.target.closest('[data-tbh-size-close]');
    if (closeButton instanceof HTMLElement) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const modal = event.target.closest('dialog.tbh-size-chart-modal');
    if (modal instanceof HTMLDialogElement && event.target === modal) {
      modal.close();
    }
  });
})();
